import { FormControlLabel, Stack, Switch } from '@mui/material';
import { ReactNode } from 'react';

import InfoTooltip from '../InfoTooltip';

interface FormSwitchInputProps {
  checked: boolean;
  disabled?: boolean;
  field: any;
  infoTooltip?: ReactNode;
  label: string;
  name: string;
  required?: boolean;
}

const FormSwitchInput = ({
  checked,
  disabled,
  field,
  infoTooltip,
  label,
  name,
  required,
}: FormSwitchInputProps) => {
  return (
    <Stack direction="row" alignItems="center">
      <FormControlLabel
        {...field}
        checked={checked}
        control={
          <Switch
            color="secondary"
            slotProps={{
              input: {
                ['data-testid']: name,
              } as React.InputHTMLAttributes<HTMLInputElement>,
            }}
          />
        }
        disabled={disabled}
        label={label}
        labelPlacement="start"
        name={name}
        required={required}
      />
      {infoTooltip && <InfoTooltip infoMessage={infoTooltip} />}
    </Stack>
  );
};

export default FormSwitchInput;
